import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import App from "./App";
import { msalInstance, initAuth } from "@/lib/auth";
import { AuthGate } from "@/components/auth-gate";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const app = (
  // react-router v7: the v6 `future` migration flags are gone — their
  // behaviors are the defaults now.
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// initAuth resolves immediately when auth is off; when on, it initializes
// MSAL and completes any pending login redirect BEFORE first render, so the
// gate never flashes the sign-in screen at an already-signed-in user.
void initAuth().then(() => {
  root.render(
    <React.StrictMode>
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>
          <AuthGate>{app}</AuthGate>
        </MsalProvider>
      ) : (
        app
      )}
    </React.StrictMode>
  );
});
